/**
 * R24 · Anzeige-Politur: (Kopie) aus Titeln, Bild-Einpassung, Reihen-Buehnen
 *
 * Ausgelagert aus snippets/r24-home-polish.liquid (perf/pdp-weight, 23.09.2026): vorher inline und
 * parserblockierend in jeder Seite, jetzt gecacht und `defer` (laeuft nach dem
 * Parsen, vor DOMContentLoaded). Kein Liquid in dieser Datei.
 */
(function () {
  /* „(Kopie)" aus sichtbaren Produkttiteln entfernen — nur Textknoten säubern,
     damit Icons/Kinder erhalten bleiben. Der Daten-Fix (echte Umbenennung) läuft
     separat; dies ist das Anzeige-Sicherheitsnetz für künftige Kopien. */
  function clean() {
    try {
      document.querySelectorAll('.t4s-product-info__inner a[href*="/products/"], .t4s-widget__pr-title, .t4s-product-info__title, a[href*="/products/"]').forEach(function (el) {
        if (!/\(Kopie\)/i.test(el.textContent)) return;
        el.childNodes.forEach(function (n) {
          if (n.nodeType === 3 && /\(Kopie\)/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\s*\(Kopie\)/gi, '');
        });
      });
    } catch (e) {}
  }
  /* Karusselle laden Produkte LAZY nach DOMContentLoaded → einmaliges Säubern
     verpasst sie. Daher: initial + auf 'load' + MutationObserver (debounced),
     der sich nach ~12 s selbst abschaltet, wenn alles gerendert ist. */
  /* Inhalts-Reihen abwechselnd markieren → visuelle „Bühnen" (zarte Wechsel-BG).
     Nur direkte #MainContent-Sektionen mit echter Höhe; idempotent. */
  function tagRows() {
    try {
      var main = document.getElementById('MainContent');
      if (!main) return;
      var secs = [].filter.call(main.children, function (c) {
        return c.classList && c.classList.contains('shopify-section') && c.getBoundingClientRect().height > 40;
      });
      secs.forEach(function (el, i) { el.classList.toggle('r24-row-alt', i % 2 === 1); });
    } catch (e) {}
  }
  /* Themenpassendes Icon vor jeden Sektions-Titel setzen (moderne, eindeutige
     Reihen-Kennzeichnung). Keyword → Line-Awesome-Icon; idempotent. */
  function addIcons() {
    try {
      var map = [['sofa|couch','la-couch'],['schlaf|bett|boxspring','la-bed'],['bad|wasch','la-bath'],
        ['kommod','la-archive'],['küch|kitchen','la-utensils'],['kollekt|überblick|zuhause','la-th-large'],
        ['neu|sortiment','la-gem'],['partner|plattform','la-handshake'],['qualit|service|sicher','la-shield-alt']];
      document.querySelectorAll('#MainContent .t4s-section-title').forEach(function (t) {
        if (t.querySelector('.r24-sec-ic')) return;
        var span = t.querySelector('span'); if (!span) return;
        var txt = t.textContent.toLowerCase(), icon = 'la-gem';
        for (var i = 0; i < map.length; i++) { if (new RegExp(map[i][0]).test(txt)) { icon = map[i][1]; break; } }
        var ic = document.createElement('i'); ic.className = 'las ' + icon + ' r24-sec-ic'; ic.setAttribute('aria-hidden', 'true');
        span.insertBefore(ic, span.firstChild);
      });
    } catch (e) {}
  }
  /* Partner-Logo-Links (OTTO/XXXLutz/Kaufland → externe ROYAL24-Shops) in
     neuem Tab öffnen, sicher (noopener). */
  function partnerLinks() {
    try {
      document.querySelectorAll('.t4s-logo-item a[href^="http"]').forEach(function (a) {
        if (!/royal-markt\.de|myshopify/.test(a.href)) { a.target = '_blank'; a.rel = 'noopener noreferrer'; }
      });
    } catch (e) {}
  }
  /* SMART FIT: pro Produktbild die Ecken abtasten (kleine, CORS-fähige Probe von
     der Shopify-CDN) → weiße Ecken = Freisteller (contain), sonst Lifestyle (cover).
     Idempotent (data-r24fit), überspringt noch nicht geladene Lazy-Bilder. */
  function r24RunFit(wrap, img) {
    if (wrap.hasAttribute('data-r24fit')) return;
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('data:') === 0 || img.naturalWidth <= 1) return;  /* Lazy-Platzhalter überspringen */
    wrap.setAttribute('data-r24fit', '1');
    var probe = new Image(); probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var s = 20, c = document.createElement('canvas'); c.width = s; c.height = s;
        var ctx = c.getContext('2d'); ctx.drawImage(probe, 0, 0, s, s);
        var pts = [[1, 1], [s - 2, 1], [1, s - 2], [s - 2, s - 2]], white = 0, tot = 0;
        pts.forEach(function (p) { var d = ctx.getImageData(p[0], p[1], 2, 2).data; for (var i = 0; i < d.length; i += 4) { tot++; if (d[i] > 236 && d[i + 1] > 236 && d[i + 2] > 236) white++; } });
        wrap.classList.add((white / tot) > 0.75 ? 'r24-fit-contain' : 'r24-fit-cover');
      } catch (e) { wrap.classList.add('r24-fit-cover'); }
    };
    probe.onerror = function () { wrap.classList.add('r24-fit-cover'); };
    probe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=64';
  }
  /* Performance: die Canvas-/Probe-Arbeit NIE den kritischen Render blockieren
     → auf requestIdleCallback verschieben (Fallback setTimeout). */
  var r24Idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
  function fitIdle(wrap, img) { r24Idle(function () { r24RunFit(wrap, img); }); }
  /* Lazysizes tauscht src per Attribut (kein childList) → an 'load' + 'lazyloaded'
     jedes Bildes binden statt nur einmal zu scannen. Idempotent pro Wrap. */
  function smartFitAll() {
    try {
      document.querySelectorAll('#MainContent .t4s-product-img.t4s_ratio').forEach(function (wrap) {
        if (wrap.__r24fitBound) { fitIdle(wrap, wrap.querySelector('img')); return; }
        var img = wrap.querySelector('img'); if (!img) return;
        wrap.__r24fitBound = true;
        img.addEventListener('load', function () { fitIdle(wrap, img); });
        fitIdle(wrap, img);
      });
    } catch (e) {}
  }
  function start() {
    /* Ab Startseite-2026: bei vorhandener neuer Hero-Sektion dieses alte Homepage-
       Overlay komplett überspringen (die neuen Sektionen bringen ihr eigenes
       Layout/Bild-Handling mit). Live (altes Layout) läuft unverändert weiter. */
    if (document.querySelector('.r24-hero-2026, .r24h-hero-wrap')) return;
    clean();
    tagRows();
    addIcons();
    partnerLinks();
    smartFitAll();
    var t, obs;
    try {
      obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { clean(); smartFitAll(); }, 180); });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 14000);
    } catch (e) {}
    window.addEventListener('load', function () { clean(); smartFitAll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
